<template>
  <div id="contenedor-editar-subtipo-infraestructura">
    <v-form v-model="formularioValido" ref="agregarNuevoSubtipoInfraestructura">
      <v-card>
        <v-card-title class="secondary--text">
          Editar subtipo de infraestructura
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            v-model="subtipoInfraestructura.idTipoInfraestructura"
            label="Tipo de Infraestructura"
            :items="getTiposInfraestructura"
            item-text="descripcion"
            item-value="id"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-select>
          <custom-text-field
            label="Descripción"
            v-model="subtipoInfraestructura.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarSubtipoInfraestructura"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixSubtiposInfraestructura from './mixSubtiposInfraestructura';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarSubtipoInfraestructura',
  mixins: [mixSubtiposInfraestructura],
  props: {
    subtipoInfraestructuraEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      subtipoInfraestructura: {
        idTipoInfraestructura: this.subtipoInfraestructuraEditar.idTipoInfraestructura,
        descripcion: this.subtipoInfraestructuraEditar.descripcion,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.agregarNuevoSubtipoInfraestructura.reset();
    },
  },
};
</script>

<style lang="scss" scoped></style>
